module.exports = __webpack_public_path__ + "static/img/0545_5.7382a44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0545_5.jpg
// module id = 41rL
// module chunks = 1